/*
 * pdp-extras.js — ficha de producto (Carnival)
 *  1. Estados de stock por talla/color: disponible / últimas piezas / agotada (no depende solo del color)
 *  2. "Avísame cuando vuelva mi talla" para la variante agotada seleccionada
 *  3. Fecha estimada en el bloque de confianza
 *  4. "Completa tu coordinado" (brasier <-> panty) con alta de ambas piezas al carrito
 * Todo degrada sin romper: si falta un dato o un elemento, la función se omite.
 */
(function () {
  'use strict';

  var STATE_TEXT = {
    ok: '',
    low: ', últimas piezas',
    soldout: ', agotada',
    none: ', no disponible en esta combinación'
  };

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- 1 y 2. Stock por variante + aviso de reabastecimiento ---------- */
  function initVariants(dataEl) {
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var sectionId = dataEl.id.replace('PdpVariants-', '');
    var root = dataEl.closest('section') || document;
    var radiosHost = root.querySelector('variant-radios');
    if (!radiosHost || !data.variants) return;

    var variants = data.variants;
    var low = Number(data.lowStock) || 3;

    function selection() {
      var sel = [];
      radiosHost.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        sel[Number(input.dataset.optionIndex) - 1] = input.value;
      });
      return sel;
    }

    function stateFor(pos, val, sel) {
      var matches = variants.filter(function (v) {
        if (v.o[pos - 1] !== val) return false;
        return sel.every(function (sv, i) { return i === pos - 1 || !sv || v.o[i] === sv; });
      });
      if (!matches.length) return 'none';
      var avail = matches.filter(function (v) { return v.a; });
      if (!avail.length) return 'soldout';
      var isLow = avail.every(function (v) { return v.q !== null && v.q > 0 && v.q <= low; });
      return isLow ? 'low' : 'ok';
    }

    function applyStates() {
      var sel = selection();
      radiosHost.querySelectorAll('fieldset').forEach(function (fs) {
        var seen = {};
        fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var label = input.nextElementSibling;
          if (!label || label.tagName !== 'LABEL') return;
          var st = stateFor(Number(input.dataset.optionIndex), input.value, sel);
          seen[st] = true;
          label.dataset.stockState = st;
          input.disabled = st === 'none';
          var sr = label.querySelector('.pdp-pill-state');
          if (sr) sr.textContent = STATE_TEXT[st];
          if (st === 'soldout') label.title = 'Agotada: puedes pedir que te avisemos';
          else if (st === 'low') label.title = 'Últimas piezas';
          else if (st === 'none') label.title = 'No disponible en esta combinación';
          else label.removeAttribute('title');
        });
        var legend = fs.querySelector('[data-stock-legend]');
        if (legend) {
          legend.querySelectorAll('li').forEach(function (li) {
            var k = li.className.match(/--(ok|low|soldout)/);
            li.hidden = !(k && seen[k[1]]);
          });
          legend.hidden = !(seen.low || seen.soldout);
        }
      });
    }

    function currentVariant() {
      var sel = selection();
      return variants.filter(function (v) {
        return sel.length && sel.every(function (sv, i) { return v.o[i] === sv; });
      })[0] || null;
    }

    function refresh() { applyStates(); }
    radiosHost.addEventListener('change', function () { setTimeout(refresh, 20); });
    refresh();
  }

  /* ---------- 3. Fecha estimada ---------- */
  function initDeliveryDate() {
    var targets = document.querySelectorAll('[data-pdp-delivery-date]');
    if (!targets.length) return;
    function fill() {
      var src = document.getElementById('shipping-date-duplicate') || document.getElementById('shipping-date') || document.getElementById('announce-shipping-date');
      var txt = src && src.textContent.trim();
      if (txt) targets.forEach(function (t) { t.textContent = txt; });
    }
    fill();
    window.addEventListener('load', fill);
  }

  /* ---------- 4. Completa tu coordinado ---------- */
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MXN';
    try { return new Intl.NumberFormat('es-MX', { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(cents / 100); }
    catch (e) { return '$' + Math.round(cents / 100); }
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function findPartnerByCode(code) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(code) +
      '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,variants.sku,tag';
    return getJSON(url).then(function (res) {
      var list = (res.resources && res.resources.results && res.resources.results.products) || [];
      var byName = list.filter(function (p) { return (p.title + ' ' + p.handle).indexOf(code) !== -1; });
      var candidates = byName.length ? byName : list;
      var i = 0;
      function next() {
        if (i >= candidates.length) return Promise.reject(new Error('sin par'));
        return getJSON('/products/' + candidates[i++].handle + '.js').then(function (prod) {
          var ok = (prod.title + ' ' + prod.handle).indexOf(code) !== -1 ||
            prod.variants.some(function (v) { return v.sku && v.sku.indexOf(code) === 0; });
          return ok ? prod : next();
        }, next);
      }
      return next();
    });
  }

  // partner-code puede traer varios códigos separados por coma (panty 7xxxx o tanga 6xxxx)
  function findPartner(el) {
    var handle = el.dataset.partnerHandle;
    var codes = (el.dataset.partnerCode || '').split(',').filter(Boolean);
    if (handle) return getJSON('/products/' + handle + '.js');
    if (!codes.length) return Promise.reject(new Error('sin código'));
    var i = 0;
    function tryNext() {
      if (i >= codes.length) return Promise.reject(new Error('sin par'));
      return findPartnerByCode(codes[i++]).catch(tryNext);
    }
    return tryNext();
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function initCoord(box) {
    var sectionId = box.dataset.section;
    var body = box.querySelector('[data-coord-body]');
    var errBox = box.querySelector('[data-coord-error]');
    var form = document.getElementById('product-form-' + sectionId);
    if (!body || !form) return;
    var idInput = form.querySelector('input[name="id"]');
    var ownHandle = box.dataset.productHandle || location.pathname.replace(/^.*\/products\//, '').replace(/\/.*$/, '');

    Promise.all([getJSON('/products/' + ownHandle + '.js'), findPartner(box)]).then(function (r) {
      var own = r[0], partner = r[1];
      if (!partner || partner.id === own.id) return;
      var partnerAvail = partner.variants.filter(function (v) { return v.available; });
      if (!partnerAvail.length) return; // sin tallas disponibles: no se ofrece

      var ownRow = el('div', 'pdp-coord__row');
      var ownImg = el('img', 'pdp-coord__img'); ownImg.alt = ''; ownImg.width = 64; ownImg.height = 80; ownImg.loading = 'lazy';
      var ownInfo = el('div', 'pdp-coord__info');
      var ownName = el('p', 'pdp-coord__name', own.title);
      var ownVar = el('p', 'pdp-coord__variant');
      ownInfo.appendChild(ownName); ownInfo.appendChild(ownVar);
      ownRow.appendChild(ownImg); ownRow.appendChild(ownInfo);

      var pRow = el('div', 'pdp-coord__row');
      var pImg = el('img', 'pdp-coord__img'); pImg.alt = ''; pImg.width = 64; pImg.height = 80; pImg.loading = 'lazy';
      var pInfo = el('div', 'pdp-coord__info');
      var pName = el('a', 'pdp-coord__name pdp-coord__link', partner.title); pName.href = partner.url || ('/products/' + partner.handle);
      var selId = 'pdp-coord-size-' + sectionId;
      var selLabel = el('label', 'pdp-coord__label', 'Talla de tu ' + (box.dataset.role === 'bra' ? 'panty' : 'brasier'));
      selLabel.setAttribute('for', selId);
      var sel = el('select', 'pdp-coord__select'); sel.id = selId;
      partner.variants.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v.id;
        o.textContent = (v.public_title || v.title) + (v.available ? '' : ' — agotada');
        o.disabled = !v.available;
        sel.appendChild(o);
      });
      pInfo.appendChild(pName); pInfo.appendChild(selLabel); pInfo.appendChild(sel);
      pRow.appendChild(pImg); pRow.appendChild(pInfo);

      var foot = el('div', 'pdp-coord__foot');
      var total = el('p', 'pdp-coord__total');
      var btn = el('button', 'button button--secondary pdp-coord__btn', 'Agregar ambas piezas');
      btn.type = 'button';
      foot.appendChild(total); foot.appendChild(btn);

      body.appendChild(ownRow); body.appendChild(el('span', 'pdp-coord__plus', '+')); body.appendChild(pRow); body.appendChild(foot);

      function ownVariant() {
        var id = Number(idInput && idInput.value);
        return own.variants.filter(function (v) { return v.id === id; })[0] || own.variants[0];
      }
      function colorOf(variant, prod) {
        var idx = -1;
        prod.options.forEach(function (o, i) { if (/color|colour/i.test(o.name || o)) idx = i; });
        return idx > -1 ? variant['option' + (idx + 1)] : null;
      }
      var preselected = false;
      function preselect() {
        if (preselected) return;
        preselected = true;
        var color = colorOf(ownVariant(), own);
        var pick = (color && partnerAvail.filter(function (v) { return colorOf(v, partner) && colorOf(v, partner).toLowerCase() === color.toLowerCase(); })[0]) || partnerAvail[0];
        sel.value = pick.id;
      }
      function partnerVariant() {
        var id = Number(sel.value);
        return partner.variants.filter(function (v) { return v.id === id; })[0];
      }
      function render() {
        var ov = ownVariant(), pv = partnerVariant();
        var oi = (ov.featured_image && ov.featured_image.src) || (own.featured_image) || '';
        var pi = (pv && pv.featured_image && pv.featured_image.src) || partner.featured_image || '';
        if (oi) ownImg.src = oi.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2'); else ownImg.hidden = true;
        if (pi) pImg.src = pi.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2'); else pImg.hidden = true;
        ownVar.textContent = (ov.public_title || ov.title || '') + (ov.available ? '' : ' — agotada');
        var ok = ov.available && pv && pv.available;
        total.textContent = ok ? 'Juntas: ' + money(ov.price + pv.price) : (ov.available ? '' : 'Elige una talla disponible de este modelo');
        btn.disabled = !ok;
      }
      preselect(); render();
      sel.addEventListener('change', function () { errBox.hidden = true; render(); });
      var host = form.closest('.product__info-container') || document;
      host.addEventListener('change', function () { setTimeout(render, 80); });

      btn.addEventListener('click', function () {
        var ov = ownVariant(), pv = partnerVariant();
        if (!ov || !pv || !ov.available || !pv.available) return;
        btn.disabled = true; btn.classList.add('loading'); errBox.hidden = true;
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var payload = { items: [{ id: ov.id, quantity: 1 }, { id: pv.id, quantity: 1 }] };
        if (cart && cart.getSectionsToRender) {
          payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
          payload.sections_url = window.location.pathname;
        }
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (r) { return r.json(); }).then(function (resp) {
          if (resp.status) {
            errBox.textContent = resp.description || 'No pudimos agregar el coordinado. Intenta de nuevo.';
            errBox.hidden = false;
            return;
          }
          if (cart && cart.renderContents && resp.sections) {
            if (resp.items && resp.items[0]) { resp.key = resp.items[0].key; resp.id = resp.items[0].id; }
            cart.renderContents(resp);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        }).catch(function () {
          errBox.textContent = 'No pudimos agregar el coordinado. Intenta de nuevo.';
          errBox.hidden = false;
        }).then(function () { btn.classList.remove('loading'); render(); });
      });

      box.hidden = false;
    }).catch(function () { /* sin par: el bloque permanece oculto */ });
  }

  ready(function () {
    document.querySelectorAll('script[id^="PdpVariants-"]').forEach(initVariants);
    initDeliveryDate();
    document.querySelectorAll('[data-pdp-coord]').forEach(initCoord);
  });
})();
